<template>
   <v-container fluid><!-- style="margin-top: -12px;"> -->

       <v-row style="width:100%; margin: -12px 0;">
      <v-data-table :loading="isLoading" :disableFiltering="true" fixed-header
            :headers="headers" :class="tableConfig.onRowSelect?'row-pointer':''"
						ref = "dataTable"
						:loading-text="$t('common.table.loading')"
						:no-data-text="$t('common.table.no_data')"
						:no-results-text="$t('common.table.no_results')"
            :options.sync="options" 
						:server-items-length="20"
            :items="data" 
						:disablePagination="true" 
						hide-default-footer
            :fixedHeader="true" 
						:height="tableHeight" 
						style="max-height: 400px; width: 100%;"
            @click:row="onRowSelected"
        >
        <template v-slot:[`item.composite_assessment_modules`]="{ item }">
          {{ getAssessmentModules(item.modules) }}
        </template>
        <template v-slot:[`item.composite_assessment_status`]="{ item }">
          <span :style="'color: ' + getAssessmentStatusColor(item.status)">{{ getAssessmentStatusText(item.status) }}</span>
        </template>

        </v-data-table>
     </v-row>

    </v-container>
</template>

<script> 
import api from '../../../api/humanway.js';
import BaseModule from '../../common/BaseModule.js';
import CommonFormatter from '../../common/CommonFormatter.js';
import { EventBus }  from './../../util/event-bus.js';

export default {
  name: 'TableWidget',
  mixins: [BaseModule, CommonFormatter],
  components: { 

  },
   props: ['config','context'],
  
  data() {
      return {
        isLoading: true,
        options: {},
        headers: [],
        data: [],
        tableConfig: {},
        tableHeight: 200
      }
  },
	mounted() {
  },
  methods: {
    onRowSelected(item) {
        if (!this.tableConfig.onRowSelect) {
            return;
        }
        EventBus.$emit('widget-data-click',{ mode:this.tableConfig.onRowSelect.mode,type:this.tableConfig.onRowSelect.type,action:this.tableConfig.onRowSelect.action, payload:item[this.tableConfig.onRowSelect.payload]});
    },
    loadData() {
        if (!this.config && !this.config.fields) {
            return;
        }
        const me = this;
        me.isLoading=true;
        this.tableConfig = JSON.parse(me.config.fields);
        const fields = this.tableConfig.headers?this.tableConfig.headers:this.tableConfig;
        me.headers = [];

        for(var k in fields) {
                let item = fields[k];
                item['value'] = item['field'];
                item['text'] = this.$t(item['label']);
                item['desc'] = this.$t(item['desc']);
                item['label'] = this.$t(item['label']);

                me.headers.push(item);
            }

        const { sortBy, sortDesc } = this.options; 

        let queryContext = {
            sortBy: sortBy.length > 0 ? this.translateSortBy(sortBy[0]) : null,
            sortDesc: sortDesc.length > 0 ? sortDesc[0] : null
        };

        api.getWidgetData(this.config.id, queryContext,
					(res) => {
            me.isLoading=false;
            me.addCustomData(me, res);
            me.data = me.formatData(me,res);
            me.fixLayout(me);
					}, err => {
            console.log(err); //TODO: mostrar toast?
            this.isLoading=false;
					}
				);
    },
    translateSortBy(field) {
        /*if (field=='avatar'){
            return 'avatar_title';
        }
        if (field=='composite1'){
            return 'composite1_title';
        } 
        if (field=='composite2'){
            return 'composite2_title';
        } 
        if (field=='status'){
            return this.formatStatus(field);
        }*/
        return field;
    },
    exportData() {
        this.$refs.exportXlsx.$el.click();
    },
    designQuery() {
        this.$emit('design')
    },
    update() {
        this.loadData(this);
    },
    fixLayout(vm) {
        this.$nextTick(() => {
            vm.tableHeight = window.getComputedStyle(vm.$refs.dataTable.$el, null).getPropertyValue("max-height");
        });
    },
		downloadItem(item) {
			item
		}
  },
  watch: {
    options: {
			handler () { 
					this.loadData();
			},
			deep: true,
		},
		context: function() { 
			this.update();
		}
	},
};
</script>